export enum ImportType {
  ImportTerminalMainLanguage = 'ImportTerminalMainLanguage',
  ImportTerminalTranslation = 'ImportTerminalTranslation',
  ImportTrDocumentation = 'ImportTrDocumentation',
}
